import {
  FaMobileAlt,
  FaShoppingCart,
  FaWallet,
  FaHeartbeat,
  FaChartLine,
  FaTruck,
} from "react-icons/fa";

function ScrollingProjects() {
  const projects = [
    { name: "Inventory Management", icon: <FaChartLine /> },
    { name: "Customer Loyalty App", icon: <FaMobileAlt /> },
    { name: "Ecommerce Platform", icon: <FaShoppingCart /> },
    { name: "Blockchain Wallet", icon: <FaWallet /> },
    { name: "Insurance Mobile App", icon: <FaHeartbeat /> },
    { name: "Food Delivery App", icon: <FaTruck /> },
  ];

  const allProjects = [...projects, ...projects]; // duplicate for infinite scroll

  return (
    <div className="mt-16 overflow-hidden">
      <p className="text-center text-sm text-blue-300 font-medium tracking-widest uppercase mb-8">
        Featured Projects
      </p>

      <div className="relative w-full overflow-hidden">
        <div className="flex animate-scroll gap-8 w-max">
          {allProjects.map((project, index) => (
            <div
              key={index}
              className="flex items-center gap-3 px-6 py-3 rounded-lg bg-gradient-to-r from-blue-500 to-indigo-500 text-white font-semibold shadow-[0_0_20px_rgba(59,130,246,0.6)] hover:scale-105 transition"
            >
              <span className="text-xl">{project.icon}</span>

              {project.name}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ScrollingProjects;
